import { Grid, Typography } from "@mui/material";

const Tarjeta_Contenido_Blog = ({ titulo, subtitulo, parrafo }) => {
    return (
        <Grid container justifyContent="center" alignItems="center" size={{ xs: 12, sm: 12, md: 12 }}>
            <Grid container alignItems="center" justifyContent="center" size={{ xs: 12, sm: 12, md: 12 }}>

                {titulo && (
                    <Grid container alignItems="center" justifyContent="flex-start" size={{ xs: 12 }}>
                        <Typography
                            component="h2"
                            variant="h2"
                            sx={{
                                pb: 1,
                                pt: 10
                            }}
                        >
                            {titulo}
                        </Typography>
                    </Grid>
                )}

                {subtitulo && (
                    <Grid container alignItems="center" justifyContent="flex-start" size={{ xs: 12 }}>
                        <Typography
                            component="h2"
                            variant="h2"
                            sx={{
                                pb: 4,
                                pt: 8
                            }}
                        >
                            {subtitulo}
                        </Typography>
                    </Grid>
                )}

                <Grid container alignItems="center" justifyContent="flex-start" size={{ xs: 12 }}>
                    {Array.isArray(parrafo) ? (
                        parrafo.map((p, i) => (
                            <Grid container size={{ xs: 12 }} key={i}>
                                <Typography
                                    component="p"
                                    variant="body1"
                                    sx={{
                                        mb: 2,
                                        display: 'flex',
                                        alignItems: 'flex-start'
                                    }}
                                >
                                    {p.trim().startsWith('.') ? (
                                        <>
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    width: 5,
                                                    height: 5,
                                                    backgroundColor: 'black',
                                                    borderRadius: '50%',
                                                    marginRight: 12,
                                                    marginTop: 10,
                                                    marginLeft: 24
                                                }}
                                            ></span>
                                            <span>
                                                {p.substring(1).split(/(\*\*[^\*]+\*\*)/).map((parte, index) =>
                                                    parte.startsWith('**') && parte.endsWith('**') ? (
                                                        <span key={index} style={{ fontWeight: 500 }}>
                                                            {parte.slice(2, -2)}
                                                        </span>
                                                    ) : (
                                                        <span key={index}>{parte}</span>
                                                    )
                                                )}
                                            </span>
                                        </>
                                    ) : (
                                        p.split(/(\*\*[^\*]+\*\*)/).map((parte, index) =>
                                            parte.startsWith('**') && parte.endsWith('**') ? (
                                                <span key={index} style={{ fontWeight: 500 }}>
                                                    {parte.slice(2, -2)}
                                                </span>
                                            ) : (
                                                <span key={index}>{parte}</span>
                                            )
                                        )
                                    )}
                                </Typography>
                            </Grid>
                        ))
                    ) : (
                        <Grid container size={{ xs: 12 }}>
                            <Typography component="p" sx={{ fontSize: 16, fontWeight: 300 }}>
                                {parrafo.split(/(\*\*[^\*]+\*\*)/).map((parte, index) =>
                                    parte.startsWith('**') && parte.endsWith('**') ? (
                                        <span key={index} style={{ fontWeight: 500 }}>
                                            {parte.slice(2, -2)}
                                        </span>
                                    ) : (
                                        <span key={index}>{parte}</span>
                                    )
                                )}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Tarjeta_Contenido_Blog;
